/**
 * Stable CSS class names for E2E — SummaryAggregation SummaryList page.
 */
export const SL = {
    page: 'sa-summary-list-page',
    root: 'sa-summary-list',

    breadcrumb: 'sa-summary-list__breadcrumb',
    titleIcon: 'sa-summary-list__title-icon',
    loading: 'sa-summary-list__loading',

    list: 'sa-summary-list__list',
    listSearchBar: 'sa-summary-list__list-search-bar',
    listSearchLabel: 'sa-summary-list__list-search-label',
    dateInput: 'sa-summary-list-input--date',
    btnSearch: 'sa-summary-list-input--button-search',

    listGridContainer: 'sa-summary-list__list-grid-container',
    listGrid: 'sa-summary-list__list-grid',
    listNoRecord: 'sa-summary-list__list-no-record',
    btnEdit: 'sa-summary-list-input--button-edit',

    detail: 'sa-summary-list__detail',
    detailDateLabel: 'sa-summary-list__detail-date-label',
    detailItemsTitle: 'sa-summary-list__detail-items-title',
    detailGrid: 'sa-summary-list__detail-grid',
    detailRowColored: 'sa-summary-list__detail-row--colored',
    btnDownloadDetail: 'sa-summary-list-input--button-download-detail',
} as const;

export const slCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
